import styled from 'styled-components';
import { useRouter } from 'next/router';
import { useScrollDirection, useTranslation } from '@hooks';
import { useWindowScroll } from 'react-use';
import {
    SortButton,
    FilterButton,
    ListingCategoryMenu,
    ListingViewSection,
} from '@components/listing';
import { DefectiveSaleWarning } from '@components/ui';

const ListingMobileHeader = ({
    category,
    filterCount,
    productCount,
    openFilterModal,
    openSortModal,
    listingType,
    changeListingType,
}) => {
    const router = useRouter();
    const { t, locale } = useTranslation();
    const { y } = useWindowScroll();
    const scrollDirection = useScrollDirection();

    return (
        <HeaderWrapper isScrolling={scrollDirection === 'down' && y > 150}>
            <div
                style={{
                    paddingLeft: 15,
                }}
            >
                {router.query.category.match(/^(defolu|defective)$/) && (
                    <DefectiveSaleWarning text={t('defectiveWarningListing')} />
                )}
            </div>

            <ListingCategoryMenu
                category={category}
                filterCount={filterCount}
                locale={locale}
                productCount={productCount}
            />
            <ListingViewSection
                isDesktop={false}
                listingType={listingType}
                changeListingType={changeListingType}
            />
            <ButtonsWrapper>
                <FilterButton
                    filterCount={filterCount}
                    title={t('filter')}
                    productCount={productCount}
                    onFilterModalOpen={openFilterModal}
                />
                <SortButton
                    data-testid="sort-button"
                    title={t('sortBy')}
                    onSortModalOpen={openSortModal}
                />
            </ButtonsWrapper>
        </HeaderWrapper>
    );
};

const HeaderWrapper = styled.div`
    position: fixed;
    z-index: 99;
    top: ${({ isScrolling }) => (isScrolling ? '0' : '55px')};
    opacity: ${({ isScrolling }) => (isScrolling ? '0' : '1')};
    transition: all 0.3s ease-in;
    left: 0;
    width: 100%;
    border-bottom: 1px solid #000;
    background: white;
    padding-bottom: 8px;
    @media (min-width: 1025px) {
        display: none;
    }
`;
const ButtonsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    margin-bottom: -8px;
    margin-left: -15px;
    margin-right: -15px;
    border-width: 1px 0 0 0;
    border-style: solid;
    border-color: #000000;
`;
export default ListingMobileHeader;
